import React from "react";
import { Link } from "react-router-dom";
import { usePageTitle } from "../hooks/usePageTitle";

const DonateThanks = () => {
  usePageTitle("Thank You for Your Support!");

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        {/* Success Icon */}
        <div className="mb-6 flex justify-center">
          <div className="bg-green-500/20 p-6 rounded-full">
            <svg
              className="w-16 h-16 text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
        </div>

        {/* Thank You Message */}
        <h1 className="text-4xl font-bold text-white mb-4">Thank You! ❤️</h1>
        <p className="text-xl text-gray-300 mb-6">
          Your donation has been successfully processed!
        </p>

        {/* Card with Details */}
        <div className="bg-dark-card border border-gray-700 rounded-lg p-8 mb-8 max-w-2xl mx-auto">
          <p className="text-gray-300 mb-4 text-lg">
            Your support means the world to me and helps keep Collect Arena
            running, growing, and completely free for everyone.
          </p>
          <p className="text-gray-400 mb-6">
            Every donation goes directly toward server costs, creating new
            lists, and building features you've requested!
          </p>

          {/* What's Next */}
          <div className="border-t border-gray-700 pt-6">
            <h2 className="text-xl font-semibold text-white mb-4">
              What's Next?
            </h2>
            <ul className="text-left text-gray-300 space-y-2">
              <li className="flex items-start gap-2">
                <svg
                  className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span>
                  You'll receive a confirmation email from PayPal shortly
                </span>
              </li>

              <li className="flex items-start gap-2">
                <svg
                  className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span>Your support helps fund new lists and features</span>
              </li>

              <li className="flex items-start gap-2">
                <svg
                  className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span>Join our Discord community to stay updated!</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Call to Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/"
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition w-full sm:w-auto"
          >
            Start Playing
          </Link>

          <a
            href="https://discord.gg/473F5RGH99"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-8 rounded-lg transition w-full sm:w-auto"
          >
            Join Discord
          </a>
        </div>
      </div>
    </div>
  );
};

export default DonateThanks;
